const createErrorNotification = require('../base/components/errorNotification');
const appendToUrl = require('../util/appendToUrl');

/**
 * This will initialize the content search form
 */
function initializeSearchForm() {
    const $contentSearchContainer = $('.contentsearch-container');
    const folderId = $contentSearchContainer.data('folderid');
    const errorMessage = $contentSearchContainer.data('error-message');
    const $searchForm = $contentSearchContainer.find('.search-form').first();

    $searchForm.find('button').first().on('click', function (event) {
        event.preventDefault();
        let url = $searchForm.attr('action');
        const $searchInput = $searchForm.find('input').first();

        if (!$searchInput.val() || $searchInput.val().trim() === '') {
            return;
        }

        $searchForm.spinner().start();
        $('.error-messaging').empty();

        var urlParams = {
            folderid: folderId,
            q: $searchInput.val()
        };

        url = appendToUrl(url, urlParams);

        $.ajax({
            url: url,
            type: 'get',
            success: function (data) {
                $searchForm.spinner().stop();

                if (data.error === true) {
                    createErrorNotification($('.error-messaging'), data.message);
                    $('.error-messaging').show();
                    $('.error-messaging').delay(5000).fadeOut(300);
                    return;
                }

                const $answersContainer = $contentSearchContainer.find('.contentsearch-container__results').first();
                $answersContainer.empty();
                $answersContainer.append(data);
            },
            error: function () {
                createErrorNotification($('.error-messaging'), errorMessage);
                $('.error-messaging').show();
                $('.error-messaging').delay(5000).fadeOut(300);
                $searchForm.spinner().stop();
            }
        });
    });
}

module.exports = {
    init: function () {
        initializeSearchForm();
    }
};
